import { validationURL } from "../Config/Url";
import axios from "axios";

export const validationService = {
  validateLoginName,
  validateUserOib,
  validateUserPin,
  validateCode,
  validateTenantOib,
  validateTid,
  validatePosSerialNumber,
  validatePosTag,
  validateStoreTag,
  validatePosInventoryNumber,
};

//user validation
async function validateLoginName(loginName) {
  return axios
    .get(`${validationURL}/user/loginName/${loginName}`)
    .then((res) => Boolean(res.data.success))
    .catch((err) => true);
}

async function validateUserOib(oib) {
  return axios
    .get(`${validationURL}/user/oib/${oib}`)
    .then((res) =>
      {console.log("ss",res);
      return res.data.data ?  res.data.data : res.data.success}
    )
    .catch((err) => console.error("ss",err));
}

async function validateUserPin(pin, tenantId) {
  return axios
    .get(`${validationURL}/user/pin?pin=${pin}&tenantId=${tenantId}`, {
      timeout: 10000,
    })
    .then((res) => Boolean(res.data.success))
    .catch((err) => true);
}

//tenant validation
async function validateCode(code) {
  return axios
    .get(`${validationURL}/tenant/code/${code}`)
    .then((res) => Boolean(res.data.success))
    .catch((err) => true);
}

async function validateTenantOib(oib) {
  return axios
    .get(`${validationURL}/tenant/oib/${oib}`)
    .then((res) => Boolean(res.data.success))
    .catch((err) => true);
}

//pos validation
async function validateTid(tid, posId) {
  return axios
    .get(`${validationURL}/pos/tid/${tid}/${posId ? posId : 0}`)
    .then((res) => (res.data.tid ? false : true))
    .catch((err) => true);
}

async function validatePosSerialNumber(serialNumber, posId) {
  return axios
    .get(
      `${validationURL}/pos/serialNumber/${serialNumber}/${posId ? posId : 0}`
    )
    .then((res) => (res.data.tid ? false : true))
    .catch((err) => true);
}

async function validatePosTag(tag, storeId, tenantId) {
  return axios
    .get(
      `${validationURL}/pos/tag/${tag}?storeId=${storeId}&tenantId=${tenantId}`
    )
    .then((res) => Boolean(res.data.success))
    .catch((err) => true);
}

async function validateStoreTag(tag, tenantId) {
  return axios
    .get(`${validationURL}/store/tag/${tag}?tenantId=${tenantId}`)
    .then((res) => Boolean(res.data.success))
    .catch((err) => true);
}

async function validatePosInventoryNumber(iNumber, posId) {
  return axios
    .get(`${validationURL}/pos/inventoryNumber/${iNumber}/${posId ? posId : 0}`)
    .then((res) => (res.data.tid ? false : true))
    .catch((err) => true);
}
